import styled from '@emotion/styled';

export const Container = styled.div<{ size?: 'small' | 'normal' }>`
  display: flex;
  justify-content: space-between;
  &:not(:last-of-type) {
    padding-bottom: ${({ size }) => (size === 'small' ? '4px' : '8px')};
  }

  .title {
    min-width: 70px;
    white-space: nowrap;
  }
`;
